/**
 *   =================== INS FUNC ===========================
 */

export function getQueryUrlString(params: any) {
  return Object.keys(params)
    .map(k => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
    .join("&");
}

export function getQueryUrlStringWithObject(params: any) {
  return Object.keys(params)
    .map(k => k + "=" + params[k])
    .join("&");
}

/**
 *  ==================== INS BASE ===========================
 */
export const InsAppInfo = {
  appId: "124024574287414",
  name: "Instagram",
  version: "97.0.0.11.120",
  bundleVersion: "26.0.0.18.87 (83603364)",
  apihost: "https://i.instagram.com",
  capabilities: "36r/Bw==",
  facebookid: "124024574287414",
  secret_key_1:
    "BQJXVFUADwUDUwIOAA5SBVMBUgQHUwAPAwQBUgYPAQ9QVVIFAAIFBVRSDgEGUFVVVAdSBwMGUw4FVwUPDlMBVA==",
  secret_key_2:
    "b2g9Pj9qZW9pOWhkamQ4bzlrOG5tOWplaW5rOGxla2U6Pzhvamhvbz44ZGtsOj8/Pm04bWlsOWRvPW9lZDlrPg==",
  connection_speed: "-1kbps",
  BUILD: "114011044",
  CAPABILITIES: "36r/dw==",
  FACEBOOK_ID: "124024574287414"
};

export const iosHeaders = () => {
  return {
    "User-Agent": `${InsAppInfo.name} ${
      InsAppInfo.version
    } (iPhone10,3; iOS 11_2; en_US; en-US; scale=2.61; gamut=normal; 1080x1920) AppleWebKit/420+`,
    "Accept-Language": "en;q=1",
    "X-IG-Connection-Type": "WiFi",
    "X-IG-Capabilities": InsAppInfo.CAPABILITIES,
    "X-IG-App-ID": InsAppInfo.FACEBOOK_ID,
    "X-IG-ABR-Connection-Speed-KBPS": "0",
    "X-IG-Connection-Speed": "-1kbps",
    "X-IG-Bandwidth-Speed-KBPS": "0.000"
  };
};

export const verifyStep = {
  select_verify_method: "select_verify_method", // 选择验证方式
  verify_phone_number: "verify_phone_number", // 手机验证
  verify_code: "verify_code", // 手机验证
  verify_email: "verify_email", // 邮箱验证
  delta_login_review: "delta_login_review", // review 是我本人 | 不是我本人
  submit_phone: "submit_phone"
};
/**
 *   =================== INS ERROR ===========================
 */
export const INS_ERROR_MSG_LOGIN = `login_required`;
export const INS_ERROR_MSG_CHALLENGE = `challenge_required`;
export const INS_ERROR_MSG_REQUIRED = `feedback_required`;
export const INS_ERROR_MSG_CHECKPOINT = `checkpoint_required`;
export const INS_ERROR_OTHER = `others`;
/**
 *    ================== INS URL =============================
 */
export const baseUrl = `https://i.instagram.com/`;

export const baseGraphUrl = `https://graph.instagram.com/`;

export const loginUrl = baseUrl + `api/v1/accounts/login/`;

export const loginFBUrl = baseUrl + `api/v1/fb/facebook_signup/`;
export const GET_PROFILE_USER_INFO =
  baseUrl + `api/v1/accounts/current_user/?edit=true`;
export const EDIT_PROFILE_PICTURE = baseUrl + `api/v1/accounts/edit_profile/`;

export const loginWithTwoFactorUrl =
  baseUrl + `api/v1/accounts/two_factor_login/`;

export const sendTwoFactorLoginSmsUrl =
  baseUrl + `api/v1/accounts/send_two_factor_login_sms/`;

export const logoutUrl = baseUrl + `api/v1/accounts/logout/`;

export const changeProfilePictureUrl =
  baseUrl + `api/v1/accounts/change_profile_picture/`;

export const getChallengeMethodUrl = (apiPath: string, deviceId: string) => {
  return baseUrl + `api/v1${apiPath}?device_id=${deviceId}`;
};

export const getUserFeedUrl = (userId: any) => {
  return baseUrl + `api/v1/feed/user/${userId}`;
};

export const getUserFeedByNameUrl = (userName: string) => {
  return baseUrl + `api/v1/feed/user/${userName}/username/`;
};

export const getTimelineUrl = baseUrl + `api/v1/feed/timeline/`;

export const likeMediaUrl = (mediaId: string | number) => {
  return baseUrl + `api/v1/media/${mediaId}/like/?d=0`;
};

export const unLikeMediaUrl = (mediaId: string | number) => {
  return baseUrl + `api/v1/media/${mediaId}/unlike/`;
};

// export const deleteMediaUrl = (mediaId: string | number, mediaType: string) => {
//     return baseUrl + `api/v1/media/${mediaId}/delete?${getQueryUrlstring({
//         media_type: mediaType
//     })}`
// };

export const postMediaCommentUrl = (mediaId: any) => {
  return baseUrl + `api/v1/media/${mediaId}/comment/`;
};

export const onFollowUrl = (userId: any) => {
  return baseUrl + `api/v1/friendships/create/${userId}/`;
};

export const unFollowUrl = (userId: any) => {
  return baseUrl + `api/v1/friendships/destroy/${userId}/`;
};

export const postUserBlockUrl = (userId: any) => {
  return baseUrl + `api/v1/friendships/block/${userId}/`;
};

export const postUserUnBlockUrl = (userId: any) => {
  return baseUrl + `api/v1/friendships/unblock/${userId}`;
};

export const getProfileUserInfo =
  baseUrl + `api/v1/accounts/current_user/?edit=true`;

export const searchTopUrl = baseUrl + `api/v1/fbsearch/topsearch/`;

export const getMediaInfoUrl = (mediaId: any) => {
  return baseUrl + `api/v1/media/${mediaId}/info/`;
};

export const getMediaInfoListUrl = baseUrl + `api/v1/media/infos/`;

export const getUserInfoByIdUrl = (userId: any) => {
  return baseUrl + `api/v1/users/${userId}/info/`;
};

export const getUserInfoByNameUrl = (username: any) => {
  return baseUrl + `api/v1/users/${username}/usernameinfo/`;
};

export const searchUserUrl = baseUrl + `api/v1/users/search/`;

export const getMyLikedFeedUrl = baseUrl + `api/v1/feed/liked/`;

export const getMySavedFeedUrl = baseUrl + `api/v1/feed/saved/`;

export const getUserTagsFeedUrl = (userId: any) => {
  return baseUrl + `api/v1/usertags/${userId}/feed/`;
};

export const getTagFeedUrl = (tagName: any) => {
  return baseUrl + `api/v1/feed/tag/${tagName}/`;
};

export const getUserStoryUrl = (userId: string) => {
  return baseUrl + `api/v1/feed/user/${userId}/story/`;
};

export const getUserFollowerUrl = (userId: string) => {
  return baseUrl + `api/v1/friendships/${userId}/followers/`;
};

export const getUserFollowingUrl = (userId: string) => {
  return baseUrl + `api/v1/friendships/${userId}/following/`;
};

export const getUserBlockingUrl = baseUrl + `api/v1/users/blocked_list/`;

export const postAccountSetPublicUrl = baseUrl + `api/v1/accounts/set_public/`;

export const postMediaEnableCommentsUrl = (mediaId: string) => {
  return baseUrl + `api/v1/media/${mediaId}/enable_comments/`;
};

export const getUserFriendshipUrl = (userId: string) => {
  return baseUrl + `api/v1/friendships/show/${userId}/`;
};

export const getUsersFriendshipUrl = baseUrl + `api/v1/friendships/show_many/`;

export const getMediaLikerUrl = (mediaId: string) => {
  return baseUrl + `api/v1/media/${mediaId}/likers/`;
};

export const getMediaCommentUrl = (mediaId: string) => {
  return baseUrl + `api/v1/media/${mediaId}/comments/`;
};

export const postMediaSeenMediaIdUrl = baseUrl + `api/v1/media/seen/`;

export const postMediasViewUrl = baseGraphUrl + `logging_client_events`;

export const postStoryViewUrl = baseUrl + `api/v1/media/seen/`;

export const postPhotoUrl = (uploadId: any) => {
  return baseUrl + `rupload_igphoto/${uploadId}`;
};

export const getSuggestionsDetails = (chainedIds: any, targetId: any) => {
  return (
    baseUrl +
    `api/v1/discover/fetch_suggestion_details/?target_id=${targetId}&chained_ids=${chainedIds}`
  );
};

export const GET_USER_INFO_BY_NAME_URL = (username: any) => {
  return baseUrl + `api/v1/users/${username}/usernameinfo/`;
};

export const uploadPhotoV1Url = baseUrl + `api/v1/upload/photo/`;

export const postMediaConfigUrl = baseUrl + `api/v1/media/configure/`;

export const vipBind = baseUrl + `api/v3/offer/service/bind`;
